module.exports = __webpack_public_path__ + "static/JusticePork-91077a68618eb0644c2a1a3d9c59b0a1.png";